module.exports = __webpack_public_path__ + "static/media/proximanova-regular.3895abf7.woff";